import React, { useState } from 'react';

const gematriaValues = {
  א: 400, ל: 20, ב: 300, מ: 10, ג: 200, נ: 9, ד: 100, ס: 8, ה: 90, ע: 7,
  ו: 80, פ: 6, ז: 70, צ: 5, ח: 60, ק: 4, ט: 50, ר: 3, י: 40,
  ש: 2, כ: 30, ת: 1, ך: 30, ץ: 5, ף: 6, ן: 9, ם: 10
};

const GematriaCalculatorAtbash = () => {
  const [inputText, setInputText] = useState('');
  const [results, setResults] = useState([]);

  const calculateGematria = () => {
    // Split the input text into words
    const words = inputText.split(/\s+/);

    // Calculate gematria values for each word
    const gematriaResults = words.map(word => {
      const gematriaValue = [...word].reduce((acc, char) => {
        return acc + (gematriaValues[char] || 0);
      }, 0);
      return `${gematriaValue} : ${word}`;
    });

    // Update the state with the results
    setResults(gematriaResults.join('\n'));
  };

  const handleDownload = () => {
    const element = document.createElement('a');
    const file = new Blob([results], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = 'gematria.Atbash.txt';
    document.body.appendChild(element);
    element.click();
  };

  return (
    <div>
      <p></p>Atbash Gematria Calculator<p></p>
      <textarea
        rows="10"
        cols="50"
        placeholder="Enter Hebrew text here..."
        value={inputText}
        onChange={e => setInputText(e.target.value)}
      ></textarea>
      <br />
      <button onClick={calculateGematria}>Calculate Gematria</button>
      <button onClick={handleDownload}>Download Gematria File</button>
      <div>
        
        <pre>{results}</pre>
      </div>
    </div>
  );
};

export default GematriaCalculatorAtbash;
